import React from 'react'

import LayoutDefault from '../../components/LayoutDefault'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import PageTitle from '../../components/PageTitle'
import FormLogin from '../../components/FormLogin'

const LoginTemplate = ({ headerProps, footerProps, layoutProps, pageTitleProps, formLoginProps }) => {
  return (<LayoutDefault
    {...layoutProps}
    header={(
      <Header {...headerProps} />
    )}
    title={(
      <PageTitle {...pageTitleProps} />
    )}
    content={(
      <>
        <FormLogin
          {...formLoginProps}
        />
      </>
    )}
    footer={(
      <Footer {...footerProps} />
    )}
  />
  )
}

export default LoginTemplate